module.exports={
  "_from": "yasgui-utils@https://registry.npmjs.org/yasgui-utils/-/yasgui-utils-1.6.7.tgz",
  "_id": "yasgui-utils@1.6.7",
  "_inBundle": false,
  "_integrity": "sha1-K8/FoxVojeOuYFeIPZrjQrIF8mc=",
  "_location": "/yasgui-utils",
  "_phantomChildren": {},
  "_requested": {
    "type": "remote",
    "raw": "yasgui-utils@https://registry.npmjs.org/yasgui-utils/-/yasgui-utils-1.6.7.tgz",
    "name": "yasgui-utils",
    "escapedName": "yasgui-utils",
    "rawSpec": "https://registry.npmjs.org/yasgui-utils/-/yasgui-utils-1.6.7.tgz",
    "saveSpec": "https://registry.npmjs.org/yasgui-utils/-/yasgui-utils-1.6.7.tgz",
    "fetchSpec": "https://registry.npmjs.org/yasgui-utils/-/yasgui-utils-1.6.7.tgz"
  },
  "_requiredBy": [
    "/",
    "/yasgui-yasqe"
  ],
  "_resolved": "https://registry.npmjs.org/yasgui-utils/-/yasgui-utils-1.6.7.tgz",
  "_spec": "yasgui-utils@https://registry.npmjs.org/yasgui-utils/-/yasgui-utils-1.6.7.tgz",
  "_where": "/home/lrd900/yasgui/yasr",
  "author": {
    "name": "Laurens Rietveld"
  },
  "bugs": {
    "url": "https://github.com/YASGUI/Utils/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "store": "^2.0.4"
  },
  "deprecated": false,
  "description": "Utils for YASGUI libs",
  "homepage": "https://github.com/YASGUI/Utils",
  "licenses": [
    {
      "type": "MIT",
      "url": "http://yasgui.github.io/license.txt"
    }
  ],
  "main": "src/main.js",
  "maintainers": [
    {
      "name": "Laurens Rietveld",
      "email": "laurens.rietveld@gmail.com",
      "url": "http://laurensrietveld.nl"
    }
  ],
  "name": "yasgui-utils",
  "repository": {
    "type": "git",
    "url": "git://github.com/YASGUI/Utils.git"
  },
  "version": "1.6.7"
}
